import * as Blockly from 'blockly/core';
import 'blockly/python';
import { AreaService } from '@/services/area.service';
import { /*getAllowedOutputs*/ getAllowedStatements } from './strata_compatibility_checks';

Blockly.Blocks['strata_predictive_convergence'] = {
    init: function() {

        let areas = AreaService.getAreas("strata");

        this.appendDummyInput("block_title")
            .appendField("Climate projection trends");

        this.appendDummyInput("time_period")
                .appendField("Time period  ")
                .appendField(new Blockly.FieldDropdown([
                    ["2030","2030"],
                    ["2050","2050"],
                    ["2080","2080"]]),"timeperiod")
        
        this.appendDummyInput('zone_input')
                .appendField("Zone ")
                .appendField(new Blockly.FieldDropdown(areas.zones), "zone")
        
        this.appendDummyInput('area_input')
            .appendField("Country ")
            .appendField(new Blockly.FieldDropdown(areas.countries.hoa), "area")
        
        this.appendDummyInput("scenario")
            .appendField("Scenario ")
            .appendField(new Blockly.FieldDropdown([
                ["RCP4.5","rcp45"],
                ["RCP8.5","rcp85"]]),"scenario")

        
        this.appendDummyInput("empty_row")
        this.appendDummyInput("section1_title")
                .appendField("Climate projection indicators")
        this.appendStatementInput("PRED_INDICATORS")
                .setCheck(getAllowedStatements('predictive_indicators'));

        this.setNextStatement(true, getAllowedStatements('strata_predictive_outputs'));

        this.setStyle('convergence'); 
        this.setHelpUrl("");
        }
        
};